import locale from "@bonliva-crm/locale";
import { Box, InputLabel, Typography, makeStyles } from "@material-ui/core";
import { GroupBase } from "react-select5";
import ReactCreatableSelect, { CreatableProps } from "react-select5/creatable";
import { ValueContainerComponent } from "./components/multi-value";
import { MultiValueRemoveComponent } from "./components/multi-value-remove";
import { useCreateableSelectStyle } from "./hooks/use-creatable-select-style";

type SelectProps<
  Option,
  Group extends GroupBase<Option> = GroupBase<Option>
> = CreatableProps<Option, true, Group> & {
  inputLabel?: string;
  styleProps?: Parameters<typeof useCreateableSelectStyle<Option, true, Group>>["1"];
  maxValuesToDisplay?: { amount: number; valueToTooltipFn: (values: Option[]) => string };
};

export function MultiCreatableSelect<
  Option extends object,
  Group extends GroupBase<Option> = GroupBase<Option>
>(mainProps: SelectProps<Option, Group>) {
  const { inputLabel, styleProps, maxValuesToDisplay, ...rest } = mainProps;
  const { creatableSelectStyle, creatableSelectTheme } = useCreateableSelectStyle<
    Option,
    true,
    Group
  >({ grouped: false }, { ...styleProps });
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      {inputLabel && (
        <InputLabel>
          <Typography variant="body1" style={{ opacity: mainProps.isDisabled ? 0.5 : 1 }}>
            {inputLabel}
          </Typography>
        </InputLabel>
      )}
      <ReactCreatableSelect<Option, true, Group>
        placeholder=""
        components={{
          DropdownIndicator: null,
          MultiValueRemove: (p) => MultiValueRemoveComponent(p),
          ValueContainer: (p) => ValueContainerComponent({ ...p, maxValuesToDisplay })
        }}
        styles={creatableSelectStyle}
        theme={(theme) => ({
          ...theme,
          ...creatableSelectTheme
        })}
        backspaceRemovesValue={false}
        noOptionsMessage={() => locale.NoMoreSearchResults}
        isMulti={true}
        isClearable={false}
        {...rest}
      />
    </Box>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    rowGap: "0.5rem"
  }
}));

export default MultiCreatableSelect;
